// Current lunch week (Mon–Sat) in Europe/Helsinki; on Sunday shows the coming week
export const getLunchWeek = (now = new Date(), lang = 'fi') => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Helsinki', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  const [y, m, d] = parts.split('-').map(Number);
  const today = new Date(Date.UTC(y, m - 1, d));
  const dow = today.getUTCDay();
  const offset = dow === 0 ? 1 : 1 - dow;
  const monday = new Date(today);
  monday.setUTCDate(today.getUTCDate() + offset);
  const saturday = new Date(monday);
  saturday.setUTCDate(monday.getUTCDate() + 5);

  const thursday = new Date(monday);
  thursday.setUTCDate(monday.getUTCDate() + 3);
  const yearStart = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 1));
  const week = Math.ceil(((thursday - yearStart) / 86400000 + 1) / 7);

  const fmt = (dt, withMonth = true) => `${dt.getUTCDate()}.${withMonth ? `${dt.getUTCMonth() + 1}.` : ''}`;
  const sameMonth = monday.getUTCMonth() === saturday.getUTCMonth();
  const range = `${fmt(monday, !sameMonth)}–${fmt(saturday)}`;
  const word = { sv: 'Vecka', en: 'Week' }[lang] || 'Viikko';
  return { week, range, label: `${word} ${week} · ${range}` };
};
